import { Scope } from './interface'

export default function logging(scope: Scope) {
    return `
        type Severity = "default" | "debug" | "info" | "notice" | "warning" | "error" | "critical" | "alert" | "emergency";
        declare var logging: {
            default(message: any) => Promise<any>;
            debug(message: any) => Promise<any>;
            info(message: any) => Promise<any>;
            notice(message: any) => Promise<any>;
            warning(message: any) => Promise<any>;
            error(message: any) => Promise<any>;
            critical(message: any) => Promise<any>;
            alert(message: any) => Promise<any>;
            emergency(message: any) => Promise<any>;
        };
    `
}
